import { parseHttpUrl } from "utils/http-url";

export const hasPortalValue = (value) => typeof value === "string"
    && value.trim() !== ""
    && !["null", "undefined"].includes(value.trim().toLowerCase());

export const buildGameLoginUrl = (website, token) => {
    if (!hasPortalValue(token)) return null;
    try {
        const url = parseHttpUrl(website);
        if (!url) return null;
        url.pathname = "/login";
        url.searchParams.set("token", token);
        url.hash = "";
        return url.href;
    } catch {
        return null;
    }
};

export const getGameBanner = (game, token) => {
    if (game?.id == null || String(game.id).trim() === "" || game.active !== true || typeof game.title !== "string" || !game.title.trim()) return null;
    const href = buildGameLoginUrl(game.link_site, token);
    return href ? { id: game.id, title: game.title.trim(), href } : null;
};
